<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M468 96C457.3 96 447.1 100.2 439.5 107.8L381 166.3L473.7 259L532.2 200.5C539.8 192.9 544 182.7 544 172C544 161.3 539.8 151.1 532.2 143.5L496.5 107.8C488.9 100.2 478.7 96 468 96zM157 390.3L249.7 483L451 281.7L358.3 189L157 390.3zM136 414.6C134 418.3 132.4 422.3 131.2 426.4L99.5 540.5L213.6 508.8C217.7 507.7 221.7 506.1 225.4 504L136 414.6zM416.9 85.2C430.4 71.6 448.8 64 468 64C487.2 64 505.6 71.6 519.1 85.2L554.8 120.9C568.4 134.4 576 152.8 576 172C576 191.2 568.4 209.6 554.8 223.1L260.8 517.1C250.1 527.8 236.7 535.6 222.1 539.7L94.4 575.1C86.1 577.4 77.1 575.1 71 568.9C64.9 562.7 62.5 553.8 64.8 545.5L100.4 417.8C104.5 403.2 112.2 389.9 123 379.1L417 85.1z"
      fill="currentColor"
    />
  </svg>
</template>